// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SyncDoneIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SyncDoneIcon" ref={forwardedRef} {...props}>
      <path d="M7.005 8.506C4.823 8.056 3.498 9.618 3.498 11a2.5 2.5 0 0 0 2.5 2.501h3.38l1.5 1.5h-4.88a4 4 0 0 1-4-4c0-2.21 1.905-4.257 4.302-4 .654-1.37 2.08-2.5 3.698-2.5 2.03 0 3.433 1.132 4.157 3.423a3.8 3.8 0 0 1 1.4.28l-1.131 1.13A7 7 0 0 0 12.9 9.186C12.418 6.187 10.726 6 9.998 6c-1.02 0-2.114.915-2.993 2.506" />
      <path d="m13 15-1.5-1.5h3z" />
      <path d="m17.735 10.266-1.236 1.236v-.003c.034-.212.018-.914-.63-1.49l.98-.979a3.8 3.8 0 0 1 .886 1.236" />
      <path d="M18.303 9.697 13 15l-2.828-2.828 1.06-1.061L13 12.879l4.243-4.243z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SyncDoneIcon = /* @__PURE__ */ Object.assign(
  SyncDoneIconComponent,
  { displayName: 'SyncDoneIcon' },
);
